import { Component, inject } from '@angular/core';
import { FirebaseService } from '../../core/services/firebase.service';


@Component({
    selector: 'app-home-about-us',
    templateUrl: './home-about-us.component.html',
    styleUrls: ['./home-about-us.component.scss']
})
export class HomeAboutUsComponent {
  private firebaseService = inject(FirebaseService);

  isFloatButtonVisible = false;

  mouseEnter(_id: unknown){
     this.firebaseService.setFloatButton(true);
  }
}